import { Text, Box } from '@user-portal/wikr-components';
import styled from 'styled-components';

import { color } from 'theme/selectors';

export const DesktopLoginWrapper = styled(Box)`
    width: 100%;
`;

export const AccessCode = styled(Text)`
    background-color: ${color('surface-main')};
    border: 1px solid ${color('border-default')};
    border-radius: ${({ theme }) => `${theme['border-radius-medium']}px`};
    padding: 16px 8px;
    display: block;
    margin-bottom: 4px;
    min-height: 58px;
    span:nth-child(3) {
        margin-right: 4px;
    }
`;
